import { render, staticRenderFns } from "./PackageProductList.vue?vue&type=template&id=3119d259&"
import script from "./PackageProductList.vue?vue&type=script&lang=js&"
export * from "./PackageProductList.vue?vue&type=script&lang=js&"
import style0 from "./PackageProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageProductList.vue"
export default component.exports